// extracted by mini-css-extract-plugin
export default {"clientSelect":"SelectClient-module__clientSelect___Kfmoe","newClient":"SelectClient-module__newClient___DKIcM","iconWrapper":"SelectClient-module__iconWrapper___yZWxS"};